"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.001 1.5c-.566 0-1.015.464-1.015 1.02v14.514l-4.77-4.77-.105-.088-.019-.013a1.016 1.016 0 0 0-1.295 1.553l6.498 6.498.095.08.017.012a1.015 1.015 0 0 0 1.312-.107l.001-.001 6.498-6.498.088-.105.013-.019a1.015 1.015 0 0 0-1.551-1.297l-.001.001-4.75 4.75V2.499l-.013-.138L13 2.338a1.018 1.018 0 0 0-.999-.838Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M1.5 17.5a1 1 0 0 0-1 1v5h23v-5.022l-.012-.135-.004-.022a1 1 0 0 0-1.984.179v3h-19v-3.022l-.012-.135-.004-.022A1 1 0 0 0 1.5 17.5Z"
  })]
});